import Utils from "../utils.class";
const {jQuery: $} = window;

export default class PieChartCounter {
    #theme;
    #$counters;
    #sel;

    constructor(theme) {
        this.#sel = ".builder-component-pie-chart-counter";
        this.#theme = theme;
        this.#$counters = $(this.#sel);

        $(window).on("builderAnimationStart", (event, el) => this.start(event, el));
    }

    start(event, el) {
        const $el = $(el);

        if($el.is(this.#sel) && !$el.data("finished")) {
            Utils.log("Start:", el);
            const start = $el.data("start");
            const end = $el.data("end");
            const prefix = $el.data("prefix");
            const suffix = $el.data("suffix");
            const $value = $el.find(".pie-chart__text");
            const $pie = $el.find(".pie-chart__circle--active");
            const duration = $el.data("duration");

            $el.data("finished", true);
            $value.text(prefix + start + suffix);

            $({countNum: start}).animate({
                countNum: end
            },{
                duration: (duration * 1000),
                easing: 'linear',
                step: function () {
                    const formatted = Math.floor(this.countNum);
                    $value.text(prefix + formatted + suffix);
                    $pie.css('strokeDasharray', `${this.countNum} 100`);
                },
                complete: function () {
                    const formatted = Math.floor(this.countNum);
                    $value.text(prefix + formatted + suffix);
                    $pie.css('strokeDasharray', `${this.countNum} 100`);
                }
            }, 0);
        }
    }
}